import { render, staticRenderFns } from "./NovoPedidoVenda.vue?vue&type=template&id=25714cd7&scoped=true&"
import script from "./NovoPedidoVenda.vue?vue&type=script&lang=js&"
export * from "./NovoPedidoVenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25714cd7",
  null
  
)

export default component.exports